// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

export const normalizeGraphQLConnection = connectionData => {
  if (!connectionData || !connectionData.edges) return []
  return connectionData.edges.map(({ node = {} } = {}) => ({ ...node }))
}
